(function ($) {
    'use strict';

    var navbarCollapse = $('.navbar-collapse');

    window.mobileCheck();

    $('#content').breakLongURLs();
    // $('body').convertSVGsToInline();
    window.buildNavigation();
    window.exitLinkNotification();
    window.collapsibleCard();

    $('#main-content .table-responsive').addMobileTableHeaders();


    $(window).on('resize', function () {
        window.mobileCheck();

        if (!window.isMobile) {
            // hide open mobile nav when sizing up to desktop
            navbarCollapse.height('');
        }
    });

}(jQuery));

